import { render, staticRenderFns } from "./UsersApprove.vue?vue&type=template&id=2e188030&scoped=true"
import script from "./UsersApprove.vue?vue&type=script&lang=js"
export * from "./UsersApprove.vue?vue&type=script&lang=js"
import style0 from "./UsersApprove.vue?vue&type=style&index=0&id=2e188030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e188030",
  null
  
)

export default component.exports